import { Navigation, Phone } from "lucide-react";
import { BUSINESS } from "@/lib/site";
import { track } from "@/lib/analytics";

export const MapFrame = ({ className = "" }) => (
  <div className={`relative overflow-hidden rounded-2xl border border-neutral-200 bg-brand-sand ${className}`}>
    <iframe
      title="Map showing District Gaslight at 1738 14th St NW, Washington, DC"
      src={BUSINESS.mapEmbed}
      loading="lazy"
      referrerPolicy="no-referrer-when-downgrade"
      className="h-full w-full border-0"
      data-testid="location-map"
    />
  </div>
);

export const HoursList = () => (
  <ul className="divide-y divide-neutral-200 border-y border-neutral-200" data-testid="hours-list">
    {BUSINESS.hours.map(([d, h]) => (
      <li key={d} className="flex items-center justify-between py-3 text-sm">
        <span className="font-semibold">{d}</span>
        <span className="text-neutral-600">{h}</span>
      </li>
    ))}
  </ul>
);

export const EntrySteps = () => (
  <ol className="space-y-4">
    {BUSINESS.entrySteps.map((s, i) => (
      <li key={s} className="flex gap-4">
        <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-brand-lime font-display text-sm font-black">{i + 1}</span>
        <span className="pt-1 text-neutral-700">{s}</span>
      </li>
    ))}
  </ol>
);

export const ContactActions = ({ where, dark = false }) => (
  <div className="flex flex-wrap gap-3">
    <a href={BUSINESS.mapsUrl} target="_blank" rel="noopener noreferrer" onClick={() => track("directions_click", { location: where })} data-testid={`${where}-directions-button`} className="btn-lime">
      <Navigation className="h-4 w-4" /> Get directions
    </a>
    <a href={BUSINESS.phoneHref} onClick={() => track("phone_click", { location: where })} data-testid={`${where}-call-button`} className={dark ? "btn-outline-light" : "btn-outline"}>
      <Phone className="h-4 w-4" /> {BUSINESS.phone}
    </a>
  </div>
);
